// Non-cryptographic unique ID generation for DOM identifiers (class names, element IDs).
// Do NOT use this for security-sensitive purposes — use crypto.randomUUID() directly there,
// and ensure you only do so in secure contexts (HTTPS) where it is guaranteed to be available.
export function generateDomId(): string {
  // Cast to optional types so TypeScript accepts the feature-detect as meaningful.
  // The DOM lib declares crypto as always-present, but older browsers don't have randomUUID.
  /* eslint-disable-next-line */
  const g = globalThis as { crypto?: { randomUUID?: () => string } };
  if (typeof g.crypto?.randomUUID === "function") {
    return g.crypto.randomUUID();
  }
  // Fallback for pre-Chrome 92 / pre-Firefox 95 / pre-Safari 15.4.
  // Math.random is intentionally used here — this is not a cryptographic operation.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
